import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

function readJwtPayload(token) {
  try {
    const part = String(token || "").split(".")[1];
    if (!part) return null;
    const padded = part.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

/** Google returns here (fixed URL). Forward to the project GoogleOauthCallback page. */
export default function GoogleOauthCallbackEntry() {
  const [searchParams] = useSearchParams();
  const payload = readJwtPayload(searchParams.get("state"));
  const projectId = payload?.projectId;

  if (!projectId) {
    return (
      <div className="biz-panel-page biz-smsconfig-page">
        <p className="biz-banner biz-banner-error">
          Google sign-in could not return to the project page.
        </p>
      </div>
    );
  }

  return (
    <Navigate
      to={{
        pathname: `/businessprojects/${projectId}/googleoauthcallback`,
        search: `?${searchParams.toString()}`,
      }}
      replace
    />
  );
}
